
import { Placement } from '@post-office/placements-frontend/teams-screen-space-flags';
export default Placement;
